import axios from "axios";

import { IP } from "../utils/Host";

export function input1632toElementOkladki(rodzaj_legi, elementyTech, setElementyTech) {
  setElementyTech(
    elementyTech.map((t) => {
      if (rodzaj_legi == 2) {
        if (t.typ == 1) {
          return { ...t, lega: 4, ilosc_leg: 2, lega_mnoznik:2 };
        }else {
          return t;
        }

      }

      if (rodzaj_legi == 4) {
        if (t.typ == 1) {
          return { ...t, lega: 4, ilosc_leg: 4, lega_mnoznik:4 };
        }else {
          return t;
        }

      }



    })
  );
}
